import axios from 'axios'
const api_base = process.env.REACT_APP_USER_API_URL

class API {
	static verifyInviteToken = async (token) => {
		let errorMessage	= 'Invitation link expired'
		let requestUrl		= `${api_base}/invite/authcenter/${token}`
		try {
			let response	= await axios.get(requestUrl)
			return response.data.data
		}
		catch(error){
		// handle error
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				if (error.response.data.error.customer_message && error.response.data.error.customer_message.length > 0){
					errorMessage = error.response.data.error.customer_message
				}
				return {error: errorMessage}

			} else if (error.request) {
				// The request was made but no response was received
				// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				return {error: errorMessage}
			} else {
				// Something happened in setting up the request that triggered an Error
				return {error: errorMessage}
			}
		}
	}
}

export default API